import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { fetchAdvertiserList, fetchAdvertiserInfo } from '@/api/advertiser/manage.ts';
import { fetchGmakerTemplateList } from '@/api/gmaker/template';
import { saveGmakerGrant, getGmakerGrantInfo, getGmakerGrantRevenue } from '@/api/gmaker/grant.js';
import { format } from 'date-fns';
import TableList from '@/components/TableList/index.vue';
import AuthorizeRevenue from '../components/authorize-revenue.vue';
import { AdvertiserAccountTypeLabel } from '@/common/permission';

export default {
  components: {
    TableList: TableList,
    AuthorizeRevenue: AuthorizeRevenue
  },
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    subscribeTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    loading: {
      type: Boolean,
      default: false
    },

    action: {
      type: String,
      default: 'create'
    },

    demoMaxPushCount: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      formValue: {
        adv_id: '',
        expired_date: '',
        template_ids: [],
        channel_ids: [],
        account_type: '',
        subscribe_type: '',
        extra_online_limit: 0,
        extra_downloads: 0,
        invoice_id: '',
        delay_days: 0,
        is_all_template: 1,
        is_all_channel: 1,
        is_allow_gm: 1,
        is_allow_ps: 1,
        revenue: 0 // 授权金额
      },
      advertiser: {},
      optionChannels: [],
      // 广告主账单信息列表
      invoicesList: [],
      advertiserList: [],
      templateList: [],
      innerVisible: false
    };
  },


  computed: {
    switchConfig: function switchConfig() {
      return {
        activeValue: 1,
        inactiveValue: 2,
        activeColor: '#13ce66',
        inactiveColor: '#ff4949'
      };
    },
    rules: function rules() {
      var validateInit = function validateInit(rule, value, callback) {
        var reg = /(^[1-9]\d*$)/;
        if (reg.test(value) || value === 0) {
          callback();
        } else {
          callback(new Error('请输入正整数'));
        }
      };

      return {
        adv_id: [{ required: true, trigger: 'change', message: '请选择广告主' }],
        template_ids: [{ required: true, trigger: 'blur', message: '请选择模板' }],
        channel_ids: [{ required: true, trigger: 'blur', message: '请选择渠道' }],
        is_all_template: [{ required: true, trigger: 'change', message: '请选择授权模板' }],
        expired_date: [{ required: true, trigger: 'change', message: '请选择授权时间' }],
        account_type: [{
          required: true,
          trigger: 'change',
          message: '账户类型不能为空'
        }],
        subscribe_type: [{
          required: true,
          trigger: 'change',
          message: '套餐类型不能为空'
        }],
        invoice_id: [{
          required: true,
          trigger: 'change',
          message: '请选择invoice信息'
        }],
        extra_online_limit: [{
          required: true,
          trigger: 'change',
          message: '同时在线人数不能为空'
        }, {
          required: true,
          trigger: 'change',
          validator: validateInit
        }],
        extra_downloads: [{
          required: true,
          trigger: 'change',
          message: '购买下载个数不能为空'
        }, {
          required: true,
          trigger: 'change',
          validator: validateInit
        }],
        revenue: [{
          required: true,
          trigger: 'change',
          validator: validateInit
        }]
      };
    },
    pickerOptions: function pickerOptions() {
      var date = this.formValue.expired_date ? new Date(this.formValue.expired_date) : new Date();
      var months = [1, 2, 3, 6, 9, 12];
      var shortcuts = [];
      shortcuts.push({
        text: '7\u5929',
        onClick: function onClick(picker) {
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      });
      months.forEach(function (val) {
        shortcuts.push({
          text: val * 30 + '\u5929',
          onClick: function onClick(picker) {
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * val);
            picker.$emit('pick', date);
          }
        });
      });
      return {
        /* eslint-disable no-mixed-operators */
        disabledDate: function disabledDate(time) {
          return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() - 1;
        },

        shortcuts: shortcuts
        /* eslint-disable no-mixed-operators */
      };
    },
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: 'Invoice name',
        prop: 'name'
      }, {
        label: 'Name Of Business',
        prop: 'company'
      }, {
        label: 'Address',
        prop: 'address'
      }, {
        slot: 'choose-slot'
      }];
    },
    subscribe: function subscribe() {
      var _this = this;

      var temp = this.subscribeTypes.filter(function (item) {
        return item.type === _this.formValue.subscribe_type;
      });
      if (temp.length) {
        return temp[0];
      }
      return {};
    },
    subscriptionPlanList: function subscriptionPlanList() {
      return this.subscribeTypes.map(function (e) {
        return {
          label: e.name,
          value: e.type
        };
      });
    },
    subscribeTypeOnline: function subscribeTypeOnline() {
      return this.formValue.account_type === 'demo' ? 1 : this.subscribe.online_limit || 0;
    },
    subscribeTypeDownload: function subscribeTypeDownload() {
      return this.formValue.account_type === 'demo' ? 0 : this.subscribe.downloads || 0;
    },
    canFetchRevenue: function canFetchRevenue() {
      // 根据服务端计算的逻辑，涉及到计算影响的字段：
      // ExpiredDate、AccountType、SubscribeType、ExtraOnlineLimit、ExtraDownloads
      var _formValue = this.formValue,
          channel_ids = _formValue.channel_ids,
          adv_id = _formValue.adv_id,
          expired_date = _formValue.expired_date,
          account_type = _formValue.account_type,
          subscribe_type = _formValue.subscribe_type,
          extra_online_limit = _formValue.extra_online_limit,
          extra_downloads = _formValue.extra_downloads;

      return [(channel_ids || []).join(','), adv_id, expired_date, account_type, subscribe_type, extra_online_limit, extra_downloads].join('-');
    },
    accountTypeLabel: function accountTypeLabel() {
      console.log('mws_account_type', this.advertiser, this.advertiser.mws_account_type, AdvertiserAccountTypeLabel);
      return AdvertiserAccountTypeLabel[this.advertiser.mws_account_type] || '';
    }
  },

  watch: {
    authorizeInfo: {
      handler: function handler(val) {
        this.init(val);
      },

      deep: true
    },
    'formValue.adv_id': function formValueAdv_id(val) {
      if (val) {
        this.getAdvInfoById(val);
        this.getAdvInvoices(val);
      }
    },
    canFetchRevenue: function canFetchRevenue() {
      var _this2 = this;

      if (this.formValue.account_type === 'normal') {
        var params = this.getParams();
        getGmakerGrantRevenue(params, true /* 开启错误时候不展示错误消息 */
        ).then(function (res) {
          _this2.formValue.revenue = res.data.data.revenue;
        });
      }
    }
  },

  mounted: function mounted() {
    this.form = this.$refs.form;
    this.init(this.authorizeInfo);
  },


  methods: {
    getOptionChannels: function getOptionChannels() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var useCache, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                useCache = true;
                _context.next = 3;
                return _this3.$store.dispatch('config/getCommonConfig', {
                  useCache: useCache,
                  names: ['channels']
                });

              case 3:
                res = _context.sent;

                _this3.optionChannels = (_.get(res, 'channels') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    resetAuth: function resetAuth() {
      var is_allow_ps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.formValue = _extends({}, this.formValue, {
        is_allow_gm: 1,
        is_all_template: 1,
        is_all_channel: 1,
        is_allow_ps: is_allow_ps,
        template_ids: [],
        channel_ids: []
      });
    },
    handleAccountTypeChange: function handleAccountTypeChange(val) {
      var _this4 = this;

      var resetPackage = function resetPackage() {
        _this4.formValue.extra_online_limit = 0;
        _this4.formValue.extra_downloads = 0;
      };
      var utils = {
        demo: function demo() {
          var date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
          date = format(date, 'YYYY-MM-DD');
          _this4.formValue.expired_date = date;
          resetPackage();
          _this4.resetAuth();
        },
        internal: function internal() {
          var date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 365 * 10);
          date = format(date, 'YYYY-MM-DD');
          _this4.formValue.expired_date = date;
          _this4.resetAuth();
        },
        normal: function normal() {
          _this4.formValue.expired_date = '';
          _this4.formValue.subscribe_type = 'basic';
          _this4.resetSubscribeType();
          resetPackage();
          _this4.resetAuth(2);
        }
      };
      utils[val]();
    },
    getAdvInfoById: function getAdvInfoById(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, info;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getGmakerGrantInfo({
                  adv_id: id
                });

              case 3:
                res = _context2.sent;
                info = _.get(res, 'data.data.info') || {};

                _this5.formValue = _extends({}, _this5.formValue, {
                  account_type: info.account_type || '',
                  subscribe_type: info.subscribe_type || '',
                  is_allow_ps: info.is_allow_ps || 1,
                  is_allow_gm: info.is_allow_gm || 1,
                  is_all_channel: info.is_all_channel || 1,
                  channel_ids: info.channel_ids || [],
                  is_all_template: info.is_all_template || 1,
                  template_ids: info.template_ids || [],
                  expired_date: info.expired_time > 0 ? format(info.expired_time * 1000 - 1000, 'YYYY-MM-DD') : '' // 过期时间返回格式只取日期部分，通过空格切分取前面部分
                });
                console.log('advertiser info', info);
                _this5.advertiser = info;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 10]]);
      }))();
    },
    getAdvInvoices: function getAdvInvoices(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetchAdvertiserInfo({
                  id: id
                });

              case 3:
                res = _context3.sent;

                _this6.invoicesList = _.get(res, 'data.data.info.invoices') || [];
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 7]]);
      }))();
    },
    init: function init(authorizeInfo) {
      this.invoicesList = [];
      this.advertiser = {};
      this.formValue = _extends({}, this.formValue, authorizeInfo);
      console.log('this.formValue', this.formValue);
      if (this.formValue.template_ids && _.isString(this.formValue.template_ids)) {
        this.formValue.template_ids = (this.formValue.template_ids || []).map(function (item) {
          return Number(item);
        });
      }

      this.getAdvertiserList(authorizeInfo.adv_id ? { keyword: authorizeInfo.adv_id, search_field: 'id' } : {});
      this.getTemplateList();
      this.getOptionChannels();
    },
    getParams: function getParams() {
      var params = _.pick(this.formValue, ['adv_id', 'is_all_template', 'is_all_channel', 'is_allow_gm', 'is_allow_ps', 'expired_date', 'account_type', 'subscribe_type', 'extra_online_limit', 'extra_downloads', 'invoice_id', 'delay_days', 'revenue']);
      // 指定模板赋值
      if (this.formValue.is_all_template === 2 && this.formValue.template_ids.length > 0) {
        params.template_ids = this.formValue.template_ids.join(',');
      }
      // 指定渠道赋值
      if (this.formValue.is_all_channel === 2 && this.formValue.channel_ids.length > 0) {
        params.channel_ids = this.formValue.channel_ids.join(',');
      }
      return params;
    },
    innerSubmit: function innerSubmit() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var params;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                params = _this7.getParams();

                _this7.$emit('update:loading', true);
                _context4.next = 5;
                return saveGmakerGrant(params);

              case 5:
                _this7.$emit('update:loading', false);
                _this7.$emit('save-success');
                _context4.next = 14;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);
                _this7.$emit('update:loading', false);
                _this7.$emit('save-fail');

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 9]]);
      }))();
    },
    submit: function submit() {
      var _this8 = this;

      this.$refs.form.validate(function (valid) {
        if (_this8.formValue.is_allow_ps !== 1 && _this8.formValue.is_allow_gm !== 1) {
          _this8.$message.error('请确保通用模板和ps制作权限至少有一个开启');
          return;
        }
        if (valid) {
          if (_this8.formValue.account_type === 'demo') {
            // 试用账户是基础套餐
            _this8.formValue.subscribe_type = 'basic';
            _this8.resetSubscribeType();
          } else if (_this8.formValue.account_type === 'internal') {
            // 内部帐号是无限制套餐
            _this8.formValue.subscribe_type = 'unlimited';
            _this8.resetSubscribeType();
          }
          _this8.innerSubmit();
        }
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    getAdvertiserList: function getAdvertiserList(params) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetchAdvertiserList(params);

              case 2:
                res = _context5.sent;

                _this9.advertiserList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    getTemplateList: function getTemplateList(params) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetchGmakerTemplateList(_extends({}, params, { is_active: 1 }));

              case 2:
                res = _context6.sent;

                _this10.templateList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    },
    handlePlanChange: function handlePlanChange(type) {
      if (type === 'basic') {
        this.formValue.is_allow_ps = 2;
      } else {
        this.formValue.is_allow_ps = 1;
      }
      this.formValue.extra_downloads = 0;
      this.formValue.extra_online_limit = 0;
      this.resetSubscribeType();
    },
    resetSubscribeType: function resetSubscribeType() {
      this.formValue.downloads = this.subscribeTypeDownload;
      this.formValue.online_limit = this.subscribeTypeOnline;
    }
  }
};